module.exports = __webpack_public_path__ + "static/img/qr-kbank.451587b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/qr-kbank.png
// module id = TqQg
// module chunks = 150